import React from "react";


const mistakes = [
  {
    title: "Sent SMS to Prod Users from Local",
    description: "Accidentally sent SMS to production users while testing locally. Oops!",
    fix: "Implemented environment checks to block prod SMS from non-prod environments.",
    bgColor: "bg-red-400",
  },
  {
    title: "Deleted the Production Database",
    description: "Ran a cleanup script on prod instead of staging. Lost critical data.",
    fix: "Added safeguards and backups before running destructive scripts.",
    bgColor: "bg-red-600",
  },
  {
    title: "No Git, Just Push and Pray (VS Code Override Prod Code)",
    description: "No version control used. Overwrote live code directly from VS Code.",
    fix: "Introduced Git version control and mandatory code reviews.",
    bgColor: "bg-yellow-400",
  },
  {
    title: "Merged PR Without Resolving Conflicts",
    description: "Pushed code containing unresolved git conflict markers to production.",
    fix: "Enforced merge conflict resolution training and pre-merge checks.",
    bgColor: "bg-orange-400",
  },
  {
    title: "Left Debug Console Logs in Production",
    description: "Forgot to remove verbose console logs, cluttering the user's console.",
    fix: "Set up linting rules and build steps to strip console logs in production.",
    bgColor: "bg-yellow-300",
  },
  {
    title: "Created App to Zip Entire MySQL DB in Same PHP Script",
    description: "Zipped the live MySQL database on the same app, causing CPU spikes.",
    fix: "Moved backup tasks to separate offline processes with throttling.",
    bgColor: "bg-red-300",
  },
  {
    title: "Merged Code to Production Thinking You Were Maintainer",
    description: "Assumed I was the maintainer and pushed changes without coordination.",
    fix: "Implemented clear deployment ownership and communication protocols.",
    bgColor: "bg-pink-400",
  },
  {
    title: "No Jira, Just Paper Tasks from Boss",
    description: "Managed tasks on paper, leading to lost or forgotten assignments.",
    fix: "Adopted digital task management tools to track and assign work.",
    bgColor: "bg-gray-400",
  },
  {
    title: "Created a Bad System Storing Data Only in RAM (Node.js)",
    description: "Kept all data in memory only. Data vanished on server restart.",
    fix: "Redesigned system to use persistent databases with backups.",
    bgColor: "bg-red-500",
  },
  {
    title: "Bought Wrong Domain, Tried to Sell Using Google Story",
    description: "Purchased wrong domain and pitched it like Google's early domain story.",
    fix: "Learned to verify domains carefully before purchase and avoid risky flips.",
    bgColor: "bg-pink-300",
  },
  {
    title: "Merged Code with Git Conflict Markers (=======) Still In",
    description: "Accidentally pushed code containing git conflict markers to production.",
    fix: "Used automated checks and PR reviews to catch conflict markers early.",
    bgColor: "bg-red-400",
  },
];

export default function Mistakes() {
  return (
    <div
      className="bg-black text-green-400 font-mono rounded-lg shadow-lg p-6 flex flex-col"
      style={{ height: "100%", width: "100%" }}
    >
        <div
          className="bg-black text-green-400 font-mono rounded-lg shadow-lg p-6 flex flex-col overflow-y-auto"
        >
          <h1 className="text-3xl font-bold mb-6 text-center">💀 Dev Mistakes</h1>
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2">
            {mistakes.map((mistake, index) => (
              <div
                key={index}
                className={`rounded-2xl shadow-lg p-4 text-black ${mistake.bgColor}`}
              >
                <h2 className="text-xl font-semibold mb-2">{mistake.title}</h2>
                <p className="text-base">{mistake.description}</p>
              </div>
            ))}
          </div>
        </div>
    </div>
  );
}
